/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-console */
/* eslint no-param-reassign: "error" */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  blockUI,
  displayMessage,
  setRedirectTo,
  unblockUI
} from '../../core_web/store/Application.store';
import ClientFactory from '../api/ApiFactory';
import {
  AgendamentoResponseListResult,
  ContratoCarregamentoInsert,
  ContratoCarregamentoResponseResult,
  ExceptionDto,
  FiltroAgendamento
} from '../api/lar.logistica.api';
import { AppDispatch, AppThunk } from './index';

const Agendamentos = createSlice({
  name: 'Agendamentos',
  initialState: {
    listaAgendamentos: {} as AgendamentoResponseListResult,
    agendamentoContrato: {} as ContratoCarregamentoResponseResult,
    exe: {} as ExceptionDto
  },
  reducers: {
    setAgendamentos(state, action: PayloadAction<AgendamentoResponseListResult>) {
      state.listaAgendamentos = action.payload;
    },
    setAgendamentoContratos(state, action: PayloadAction<ContratoCarregamentoResponseResult>) {
      state.agendamentoContrato = action.payload;
    },
    setExeption(state, action: PayloadAction<ExceptionDto>) {
      state.exe = action.payload;
    },
    resetData(state) {
      state.listaAgendamentos = {} as AgendamentoResponseListResult;
      state.agendamentoContrato = {} as ContratoCarregamentoResponseResult;
    },
    handleClose(state, action: PayloadAction<any>) {
      if (typeof action.payload === 'function') {
        let close;
        close = action.payload;
        close();
      }
    }
  }
});

export const { setAgendamentos, setAgendamentoContratos, setExeption, resetData, handleClose } =
  Agendamentos.actions;
export default Agendamentos.reducer;

export function obterAgendamentos(
  matricula: number,
  dataInicial?: Date | undefined,
  placa?: string | undefined,
  status?: FiltroAgendamento | undefined
): AppThunk {
  return async function (dispatch: AppDispatch | any | any) {
    dispatch(blockUI());
    const client = ClientFactory.GetClient();
    client
      .apiV1AgendamentosGet(matricula, dataInicial, placa, status)
      .then((result) => {
        dispatch(setAgendamentos(result.toJSON()));
      })
      .catch((err) => {
        dispatch(
          displayMessage({
            message:
              err.message === 'Unauthorized'
                ? 'Não Autorizado, Faça novamente o login'
                : `Não foi possivel obter os agendamentos: ${err.message}`,
            severity: 'error'
          })
        );
      })
      .finally(() => dispatch(unblockUI()));
  };
}

export function obterContratoAgendamento(
  matricula: number,
  contrato: number,
  local: number
): AppThunk {
  return async function (dispatch: AppDispatch | any | any) {
    dispatch(blockUI());
    const client = ClientFactory.GetClient();
    client
      .apiV1AgendamentosContratos(matricula, contrato, local)
      .then((result) => {
        dispatch(
          setRedirectTo(`${process.env.PUBLIC_URL}/contrato/agendar/${matricula}/${contrato}`)
        );
        dispatch(setAgendamentoContratos(result.toJSON()));
      })
      .catch((err) => {
        dispatch(
          displayMessage({
            message:
              err.message === 'Unauthorized'
                ? 'Não Autorizado, Faça novamente o login'
                : `Não foi possivel obter o contrato para agendamento: ${err}`,
            severity: 'error'
          })
        );
      })
      .finally(() => dispatch(unblockUI()));
  };
}

export function postAgendarContrato(
  matricula: number,
  contrato: number,
  local: number,
  payload: ContratoCarregamentoInsert,
  recaptcha: string,
  onClose?: Function
): AppThunk {
  return async function (dispatch: AppDispatch | any) {
    dispatch(blockUI());
    const client = ClientFactory.GetClient();

    try {
      const result = await client.apiV1AgendamentosPost(
        recaptcha,
        matricula,
        contrato,
        local,
        payload
      );

      dispatch(setAgendamentoContratos(result.toJSON()));
      dispatch(
        displayMessage({
          message: `Agendamento adicionado com sucesso`,
          severity: `success`
        })
      );

      if (typeof onClose === 'function') {
        dispatch(handleClose(onClose()));
      }
    } catch (err: any) {
      const mensagem = extrairMensagemErro(err);
      dispatch(
        displayMessage({
          message: mensagem,
          severity: 'error'
        })
      );
    } finally {
      dispatch(unblockUI());
    }
  };
}

function extrairMensagemErro(err: any): string {
  if (err?.status === 401 || err?.response?.status === 401) {
    return 'Não autorizado. Faça o login novamente.';
  }

  const mensagemApi =
    err?.response?.data?.message ||
    err?.response?.data?.detail ||
    err?.response?.data?.title ||
    err?.body?.message ||
    err?.body?.detail ||
    err?.message;

  if (mensagemApi && mensagemApi !== 'Unauthorized') {
    return `Não foi possível adicionar o agendamento: ${mensagemApi}`;
  }

  if (mensagemApi === 'Unauthorized') {
    return 'Não autorizado. Faça o login novamente.';
  }

  return 'Não foi possível adicionar o agendamento. Tente novamente.';
}

export function deletarAgendarContrato(
  matricula: number,
  contrato: number,
  placa: string,
  data: Date,
  local: number
): AppThunk {
  return async function (dispatch: AppDispatch | any) {
    dispatch(blockUI());
    const client = ClientFactory.GetClient();
    client
      .apiV1AgendamentosDelete(matricula, contrato, placa, data, local)
      .then((result) => {
        const responseData = result.toJSON();
        dispatch(
          setRedirectTo(`${process.env.PUBLIC_URL}/contrato/agendar/${matricula}/${contrato}`)
        );
        dispatch(setAgendamentoContratos(responseData));
        displayMessage({
          message: `Agendamento removido com sucesso`,
          severity: 'success'
        });
      })
      .catch((err) => {
        dispatch(
          displayMessage({
            message:
              err.message === 'Unauthorized'
                ? 'Não Autorizado, Faça novamente o login'
                : `Não foi possivel remover o agendamento: ${err.message}`,
            severity: 'error'
          })
        );
      })
      .finally(() => dispatch(unblockUI()));
  };
}

export function clearData(): AppThunk {
  return async function (dispatch: AppDispatch | any | any) {
    dispatch(resetData());
  };
}
